/*
 * @providesModule MaintenancePopupWeb
 */

// Wrapper for the MaintenancePopup component for the web platform
import React from 'react';
import {createPortal} from 'react-dom';
import {MaintenancePopupWrapper} from '@sdk-mobile';

const MAINTENANCE_POPUP_ROOT_ID = 'maintenance-popup-root';

const MaintenancePopupWeb = () => {
  const container =
    typeof document !== 'undefined' ? document.getElementById(MAINTENANCE_POPUP_ROOT_ID) : null;

  if (!container) {
    return null;
  }

  return createPortal(
    <div className='maintenance-popup-layer'>
      <MaintenancePopupWrapper />
    </div>,
    container
  );
};

export default MaintenancePopupWeb;
